import * as yup from 'yup';
import { Row, RenderConfig, SelectInput } from 'commons-ui';
import { EWidgetTypes, WIDGET_TYPE_OPTIONS } from '../../utils/constants';

const FORM_FIELD_KEYS = {
	WIDGET_TYPE: 'WIDGET_TYPE'
};

export const validationSchema = yup.object().shape({
	launchWidgetType: yup.string().oneOf(Object.values(EWidgetTypes)).required('Select Widget Type is required')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.WIDGET_TYPE]: new RenderConfig()
		.setName('launchWidgetType')
		.setLabel('Widget Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: WIDGET_TYPE_OPTIONS
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.WIDGET_TYPE)];
